import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  {
    path: '/giftWall',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-GiftWall-index" */ '~/pages/GiftWall/pages/index'
        )
    ),
  },
  // 标题勋章
  {
    path: '/giftWall/rank',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-GiftWall-rank" */ '~/pages/GiftWall/pages/rank'
        )
    ),
  },
] as RouteConfig[]
